import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "row mb-0 mb-md-4" }
const _hoisted_2 = { class: "col-12 col-md-4" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = ["value", "onBlur", "onFocus"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, " Укажите дату ", -1)
const _hoisted_6 = { class: "col-12 col-md-2 d-flex align-items-center mb-2 mb-md-0" }
const _hoisted_7 = { class: "form-check form-check-inline" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label" }, "Работа в цехе", -1)
const _hoisted_9 = { class: "col-12 col-md-6" }
const _hoisted_10 = { class: "col-12 col-md-4 col-lg-3" }
const _hoisted_11 = { class: "col-12 col-md-4 col-lg-3" }
const _hoisted_12 = { class: "col-12 col-md-4 col-lg-2" }
const _hoisted_13 = { class: "col-12 col-md-auto flex-grow-1 flex-shrink-1" }
const _hoisted_14 = {
  key: 0,
  class: "col-auto flex-grow-0 flex-shrink-0"
}
const _hoisted_15 = { class: "mb-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label d-block",
  style: {"color":"#fff"}
}, ".", -1)
const _hoisted_17 = { class: "row mb-4" }
const _hoisted_18 = { class: "col-12" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-12 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_ui = _resolveComponent("loader-ui")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_form_group_ui = _resolveComponent("form-group-ui")!
  const _component_select_ui = _resolveComponent("select-ui")!
  const _component_input_ui = _resolveComponent("input-ui")!
  const _component_button_ui = _resolveComponent("button-ui")!
  const _component_modal_ui = _resolveComponent("modal-ui")!

  return (_openBlock(), _createBlock(_component_modal_ui, {
    id: _ctx.id,
    size: "modal-xl",
    title: _ctx.state.title
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "loader",
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)), ["prevent"]))
      }, [
        _createVNode(_component_loader_ui, {
          "is-show": _ctx.state.loader
        }, null, 8, ["is-show"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Выберите дату",
              label: "Дата",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_date_picker, {
                  modelValue: _ctx.state.happenedAt,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.happenedAt) = $event)),
                  class: "inline-block h-full",
                  is24hr: true,
                  mode: "date",
                  timezone: 'Asia/Almaty'
                }, {
                  default: _withCtx(({ inputValue, togglePopover }) => [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("input", {
                        class: _normalizeClass(["form-control", { 'is-invalid': _ctx.isHappenedAtError && _ctx.state.visibleErrors, 'bg-white': true }]),
                        value: inputValue,
                        onBlur: ($event: any) => (togglePopover()),
                        onFocus: ($event: any) => (togglePopover())
                      }, null, 42, _hoisted_4),
                      _hoisted_5
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.isWorkOnDepartment) = $event)),
                class: "form-check-input",
                type: "checkbox"
              }, null, 512), [
                [_vModelCheckbox, _ctx.state.isWorkOnDepartment]
              ]),
              _hoisted_8
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            (!_ctx.state.isWorkOnDepartment)
              ? (_openBlock(), _createBlock(_component_form_group_ui, {
                  key: 0,
                  "invalid-feedback": "Укажите локомотив (секцию)",
                  label: "Локомотив (секция)",
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_select_ui, {
                      "is-invalid": _ctx.state.visibleErrors && _ctx.isSectionJobIdError,
                      options: _ctx.actualSectionJobs,
                      placeholder: "Локомотив (секция)",
                      searchable: true,
                      values: [_ctx.state.sectionJobId],
                      onOnSelected: _ctx.onSectionJobSelected
                    }, null, 8, ["is-invalid", "options", "values", "onOnSelected"])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_form_group_ui, {
                  key: 1,
                  "invalid-feedback": "Укажите цех (подразделение)",
                  label: "Цех (подразделение)",
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_select_ui, {
                      "is-invalid": _ctx.state.visibleErrors && _ctx.isDepartmentError,
                      options: _ctx.departments,
                      placeholder: "Цех (подразделение)",
                      searchable: true,
                      values: [_ctx.state.departmentId],
                      onOnSelected: _ctx.onDepartmentSelected
                    }, null, 8, ["is-invalid", "options", "values", "onOnSelected"])
                  ]),
                  _: 1
                }))
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.summaryDetailsPerEmployee, (summaryEmployee, toolInd) => {
          return (_openBlock(), _createElementBlock("div", {
            key: toolInd,
            class: "row mb-4 border-bottom"
          }, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_form_group_ui, {
                "invalid-feedback": "Выберите сотрудника",
                label: "Сотрудник",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_select_ui, {
                    "is-invalid": _ctx.state.visibleErrors && _ctx.isEmployeeIdError(summaryEmployee),
                    options: _ctx.getEmployees(summaryEmployee.employeeId),
                    placeholder: "Сотрудник",
                    searchable: true,
                    values: [summaryEmployee.employeeId],
                    onOnSelected: (v) => _ctx.onEmployeeSelected(summaryEmployee, v)
                  }, null, 8, ["is-invalid", "options", "values", "onOnSelected"])
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_form_group_ui, {
                "invalid-feedback": "Укажите конструктив",
                label: "Конструктив",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_select_ui, {
                    "is-invalid": _ctx.state.visibleErrors && _ctx.isConstructIdError(summaryEmployee),
                    options: _ctx.constructives,
                    placeholder: "Конструктив",
                    searchable: true,
                    values: [summaryEmployee.subgroupId],
                    onOnSelected: (v) => _ctx.onConstructSelected(summaryEmployee, v)
                  }, null, 8, ["is-invalid", "options", "values", "onOnSelected"])
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_form_group_ui, {
                "invalid-feedback": "Укажите количество (часы)",
                label: "Количество (часы)",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_input_ui, {
                    modelValue: summaryEmployee.hoursWorked,
                    "onUpdate:modelValue": ($event: any) => ((summaryEmployee.hoursWorked) = $event),
                    "is-invalid": _ctx.state.visibleErrors && _ctx.isHoursWorkedError(summaryEmployee),
                    mask: { mask: 'Z*', tokens: { 'Z': { pattern: /[0-9]/ } } },
                    placeholder: "Количество (часы)"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "is-invalid"])
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_form_group_ui, {
                "invalid-feedback": "Примечание",
                label: "Примечание"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_input_ui, {
                    modelValue: summaryEmployee.comment,
                    "onUpdate:modelValue": ($event: any) => ((summaryEmployee.comment) = $event),
                    placeholder: "Примечание"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1024)
            ]),
            (_ctx.state.summaryDetailsPerEmployee.length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createVNode(_component_button_ui, {
                      class: "btn-outline-danger",
                      type: "button",
                      onClick: ($event: any) => (_ctx.deleteSummaryEmployee(toolInd))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" x ")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_button_ui, {
              class: "btn-outline-secondary",
              type: "button",
              onClick: _ctx.addSummaryEmployee
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Добавить сотрудника ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_button_ui, { "button-class": "btn-primary" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.state.btn), 1)
              ]),
              _: 1
            })
          ])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["id", "title"]))
}